import {
    apiRequest,
    pensiunPegawaiUpdate,
    pensiunPegawaiDetail,
    masterType
} from "../../../../../services/adapters/kepegawaian/pensiunpegawaiService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", pensiunPegawaiUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunPegawaiDetail, {
            params: query
        }, true)
    }

     fetchType = async (query) => {
        return await apiRequest("get", masterType, {
            params: query
        }, true)
    }
}

export default UpdateRepository